import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Wordmark } from "../components/JLMark";
import { Footer } from "../components/Footer";
import { INSTAGRAM_URL, EMAIL } from "../lib/site";

const SECTIONS = [
  ["Quais dados coletamos", "Ao preencher o formulário de orçamento, coletamos nome, nome da empresa, telefone ou WhatsApp, tipo de negócio, tipo de site desejado, descrição do projeto e prazo desejado (opcional). Também registramos o endereço IP do envio para prevenir abusos."],
  ["Para que usamos", "Os dados são usados exclusivamente para entrar em contato com você, elaborar o orçamento solicitado e conduzir a negociação do projeto."],
  ["Compartilhamento", "Não vendemos nem compartilhamos seus dados com terceiros para fins comerciais. Caso você opte por continuar a conversa pelo WhatsApp, a mensagem é tratada também conforme as políticas do WhatsApp."],
  ["Armazenamento e segurança", "Os dados são armazenados em ambiente protegido e mantidos apenas pelo tempo necessário para atender à sua solicitação ou cumprir obrigações legais."],
  ["Seus direitos (LGPD)", "Você pode solicitar a confirmação, o acesso, a correção ou a exclusão dos seus dados a qualquer momento, nos termos da Lei nº 13.709/2018 (LGPD)."],
];

export default function Privacy() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Política de Privacidade | JL Nexus";
    return () => { document.title = "JL Nexus | Criação de sites profissionais para empresas e comércios"; };
  }, []);

  return (
    <>
      <header className="border-b border-white/10 bg-[#080B12]">
        <div className="mx-auto flex h-[72px] max-w-[1400px] items-center justify-between px-5 sm:px-8">
          <Link to="/" aria-label="JL Nexus, página inicial" data-testid="privacy-logo-link"><Wordmark /></Link>
          <Link to="/" data-testid="privacy-back-link" className="inline-flex items-center gap-2 text-sm text-slate-300 hover:text-white"><ArrowLeft className="h-4 w-4" /> Voltar ao site</Link>
        </div>
      </header>
      <main data-testid="privacy-page" className="mx-auto max-w-3xl px-5 py-20 sm:px-8">
        <h1 className="font-display text-4xl font-semibold tracking-tight sm:text-5xl">Política de Privacidade</h1>
        <p className="mt-5 text-slate-300">Esta política explica como a JL Nexus trata os dados pessoais enviados por meio deste site.</p>
        {SECTIONS.map(([t, d]) => (
          <section key={t} className="mt-10">
            <h2 className="font-display text-xl font-semibold text-white">{t}</h2>
            <p className="mt-3 leading-relaxed text-slate-300">{d}</p>
          </section>
        ))}
        <section className="mt-10">
          <h2 className="font-display text-xl font-semibold text-white">Contato</h2>
          <p className="mt-3 leading-relaxed text-slate-300">
            Para exercer seus direitos, fale conosco pelo e-mail <a href={`mailto:${EMAIL}`} className="text-[#00C8FF] underline underline-offset-2" data-testid="privacy-email-link">{EMAIL}</a> ou pelo Instagram <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="text-[#00C8FF] underline underline-offset-2">@jlnexus.digital</a>.
          </p>
        </section>
      </main>
      <Footer />
    </>
  );
}
